/* eslint-disable no-use-before-define */
import InspectionTemplate from '../../../components/templates/InspectionTemplate';

function RegularInspectionManagerAssignmentPage() {
	return InspectionTemplate({
		productType: 'REGULAR_INSPECTION',
		departmentId: false,
	});
}

export default RegularInspectionManagerAssignmentPage;
